import './collector-wants-notif.service.js';



// WEBPACK FOOTER //
// ./components/collector/notification-prefs/index.js